import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import backgroundImg from './main_intro.jpg'
import Loader from './Loader';

// Variable global para evitar doble ejecución
let hasProcessedGlobally = false;

export default function Callback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 768;

  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const error = searchParams.get('error');

  const isMobileLogin = Boolean(
    state && (
      state === 'mobile_login' ||
      state.startsWith('mobile_login') ||
      state.startsWith('discord_link') ||
      state.startsWith('google_link') ||
      state.startsWith('kick_link') ||
      state.includes('eldenguee://') ||
      state.includes('exp://')
    )
  );

  // Extraer la URI de la app enviada desde mobile (ej: exp://192.168.x.x:8081/--/callback en Expo Go o eldenguee://callback en APK)
  let baseAppUri = 'eldenguee://callback';
  if (isMobileLogin && state.includes('|')) {
    try {
      baseAppUri = decodeURIComponent(state.split('|')[1]);
    } catch (e) {
      console.warn('Error parsing mobile app URI:', e);
    }
  }

  const joinChar = baseAppUri.includes('?') ? '&' : '?';
  const mobileRedirectUrl = isMobileLogin
    ? (error
      ? `${baseAppUri}${joinChar}error=${encodeURIComponent(error)}&state=${encodeURIComponent(state || '')}`
      : code
        ? `${baseAppUri}${joinChar}code=${encodeURIComponent(code)}&state=${encodeURIComponent(state || '')}`
        : `${baseAppUri}${joinChar}error=no_code&state=${encodeURIComponent(state || '')}`)
    : null;

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTokenExchange = async () => {
    if (hasProcessedGlobally) return;
    hasProcessedGlobally = true;

    console.log('Callback state:', state, '| code:', code ? 'present' : 'missing');

    // ── Login desde la app mobile ─────────────────────────────────────────────
    if (isMobileLogin) {
      if (mobileRedirectUrl) {
        window.location.replace(mobileRedirectUrl);
      }
      return;
    }

    // ── Login desde la web (flujo normal) ────────────────────────────────────
    const code_verifier = localStorage.getItem('kick_code_verifier');
    console.log('state', state);

    const isSorteoPath = state && state.includes("sorteo");
    const isTipeoPath = state && state.includes("tipeos");

    if (code && code_verifier) {
      try {
        const res = await fetch('https://backend.eldenguee.com/api/kick-token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code,
            code_verifier,
          }),
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data = await res.json();

        if (data.access_token) {
          localStorage.setItem('kick_token', JSON.stringify(data));

          const response = await fetch('https://api.kick.com/public/v1/users', {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${data.access_token}`,
              'Accept': 'application/json',
            },
          });

          const userData = await response.json();
          console.log('User data:', userData);
          const username = userData?.data[0]?.name;
          const emailKick = userData?.data[0]?.email;
          const kickId = String(userData?.data[0]?.id ?? '');
          const profile = userData?.data[0]?.profile_picture ?? '';

          localStorage.setItem('kick_user', username);
          localStorage.setItem('kick_mail', emailKick);
          localStorage.setItem('kick_info', JSON.stringify(userData));
          localStorage.removeItem('kick_code_verifier');
          localStorage.setItem('show_android_beta_modal', 'true');
          localStorage.setItem('show_ios_beta_modal', 'true');

          // ── Crear/actualizar usuario en la BD ─────────────────────
          if (username) {
            try {
              const upsertRes = await fetch('https://backend.eldenguee.com/infoUser/kick/upsert-user', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  nombre: username,
                  mail: emailKick || '',
                  access_token_kick: data.access_token || '',
                  refresh_token_kick: data.refresh_token || '',
                  kickId,
                  profile
                })
              });
              const upsertData = await upsertRes.json();
              console.log('[upsert-user]', upsertData);
            } catch (upsertErr) {
              // No bloqueamos el login si el upsert falla
              console.warn('[upsert-user] Error al registrar usuario en BD:', upsertErr);
            }
          }

          if (username === 'eldenguee' || username === 'lucaslunacl') {
            localStorage.setItem('kick_jwt', 'llluuuiiisss222000222666');
          }
          const redirectTo = isSorteoPath || isTipeoPath ? decodeURIComponent(state) : '/';
          window.location.href = redirectTo;
        } else {
          throw new Error('No se recibió un access_token válido');
        }
      } catch (err) {
        console.error('Error al obtener el token:', err);
        localStorage.setItem('kick_token', JSON.stringify({ error: 'Token inválido' }));
        navigate('/error');
      }
    } else {
      console.error('Faltan code o code_verifier');
      navigate('/error');
    }
  };

  useEffect(() => {
    handleTokenExchange();
  }, []);

  if (isMobileLogin) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#0b0e14',
        color: '#fff',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: 20
      }}>
        <h2 style={{ color: '#00ff73', marginBottom: 10 }}>Redirigiendo a la app...</h2>
        <p style={{ color: '#aaa', marginBottom: 20 }}>Si no volviste automáticamente, hacé click abajo:</p>
        <a
          href={mobileRedirectUrl}
          style={{
            backgroundColor: '#00ff73',
            color: '#000',
            fontWeight: 'bold',
            padding: '14px 28px',
            borderRadius: '10px',
            textDecoration: 'none',
            fontSize: '16px'
          }}
        >
          ABRIR EN LA APP
        </a>
      </div>
    );
  }

  return (
    <Loader />
  );
}